<template>
	<div class="socials">
		<a v-for="medium in socials" :key="medium.ID" :class="medium.platform" :href="medium.url" target="_blank">
			<font-awesome-icon
				v-if="!['tripadvisor', 'zoover'].includes(medium.platform)"
				:icon="`fa-brands fa-${medium.platform}`"
				size="1x"
			/>
		</a>
	</div>
</template>

<script setup>
defineProps({
	socials: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.socials .tripadvisor {
	background: url('~/assets/images/tripadvisor-small-black.png') no-repeat center center
		var(--primary-background-color);
	background-size: 20px;
	width: 36px;
	height: 36px;
	line-height: 36px;
}

.socials .tripadvisor:hover {
	background: url('~/assets/images/tripadvisor-small-black.png') no-repeat center center var(--cta-color-hover);
	background-size: 20px;
}

.socials {
	display: flex;
	align-items: center;
	place-content: center flex-start;

	a {
		color: #fff;
		display: flex;
		align-items: center;
		place-content: center center;
		line-height: 36px;
		border-radius: 50%;
		text-align: center;
		font-size: 28px;
		margin: 7px 14px 7px 0;
		text-decoration: none;

		&:hover {
			color: var(--cta-color);
		}
	}
}

@media (max-width: 680px) {
	footer .socials {
		justify-content: center;
	}
}
</style>
